import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { InfoCircle, ExclamationTriangle } from 'react-bootstrap-icons';
import utils from '../utils';

const AssetScenarioPlanningModel = (param) => {

    const [loading, setLoading] = useState(true);
    const [scenario, setScenario] = useState([]);

    useEffect(() => {
        setScenario(param.scenario);
        setLoading(false);
    }, [loading, param]);

    return loading ? (
        <p><em>Loading...</em></p>
    ) : (
        <React.Fragment>
            <Table striped>
                <thead>
                    <tr>
                        <th className="text-end">Year</th>
                        <th className="text-end">Discrete Recurring Costs</th>
                        <th className="text-end">Accumulated Recurring Costs</th>
                        <th className="text-end">Accumulated Requirements (1-3)</th>
                        <th className="text-end">Accumulated Deterioration</th>
                        <th className="text-end">Deferred Renewal</th>
                        <th className="text-end">CRV</th>
                        <th className="text-end">FCI</th>
                        <th className="text-end">Asset Deferred Renewal Funding</th>
                    </tr>
                </thead>
                <tbody>
                    {scenario.scenarioYears?.map((scenarioYear, index) =>
                        <tr key={scenarioYear.year}>
                            <td class="text-end">{scenarioYear.year}</td>
                            <td class="text-end">{utils.getDollarString(scenarioYear.discrete)}</td>
                            <td class="text-end">
                                {scenarioYear.reallocatedTo === 'recurring' && scenarioYear.surplusAmount > 0 && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-realloc-${scenarioYear.year}-rc`}>
                                                Funds re-allocated: Accumulated requirements reached $0. Applied ${((scenarioYear.recurringAlloc || 0) + (scenarioYear.surplusAmount || 0)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})} (${(scenarioYear.recurringAlloc || 0).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})} planned + ${(scenarioYear.surplusAmount || 0).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})} surplus).
                                            </Tooltip>
                                        }
                                    >
                                        <InfoCircle className="me-2" style={{ color: '#0d6efd', cursor: 'pointer' }} size={16} />
                                    </OverlayTrigger>
                                )}
                                {utils.getDollarString(scenarioYear.accum)}
                            </td>
                            <td class="text-end">
                                {scenarioYear.reallocatedTo === 'requirements' && scenarioYear.surplusAmount > 0 && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-realloc-${scenarioYear.year}-req`}>
                                                Funds re-allocated: Accumulated recurring costs reached $0. Applied ${((scenarioYear.requirementsAlloc || 0) + (scenarioYear.surplusAmount || 0)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})} (${(scenarioYear.requirementsAlloc || 0).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})} planned + ${(scenarioYear.surplusAmount || 0).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})} surplus).
                                            </Tooltip>
                                        }
                                    >
                                        <InfoCircle className="me-2" style={{ color: '#0d6efd', cursor: 'pointer' }} size={16} />
                                    </OverlayTrigger>
                                )}
                                {utils.getDollarString(scenarioYear.accumReq)}
                            </td>
                            <td class="text-end">{utils.getDollarString(scenarioYear.accumDet)}</td>
                            <td class="text-end">{utils.getDollarString(scenarioYear.modDeferred)}</td>
                            <td class="text-end">{utils.getDollarString(scenarioYear.crv)}</td>
                            <td class="text-end">{scenarioYear.fci.toFixed(2)}</td>
                            <td class="text-end">
                                {scenarioYear.hasLeftoverFunding && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-leftover-${scenarioYear.year}`}>
                                                Warning: All costs categories are fully consumed and there are excess funds remaining. Consider decreasing funding amounts.
                                            </Tooltip>
                                        }
                                    >
                                        <ExclamationTriangle className="me-2" style={{ color: '#dc3545', cursor: 'pointer' }} size={16} />
                                    </OverlayTrigger>
                                )}
                                {utils.getDollarString(scenarioYear.deferredRenewalFunding)}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </React.Fragment>
    );
}

export default AssetScenarioPlanningModel;